import { remoteLogMessage } from '@gjensidige/service-error-handler';

export const logInfoMessage = (message: string) => {
  if (window.location.hostname === 'localhost') {
    console.log(message);
  } else {
    remoteLogMessage(message, { severity: 'INFO' });
  }
};
